// Base URL of this build's BinViewer API. Set at build time per environment
// (see Makefile: prod -> api.binviewer.com, staging -> api-staging.binviewer.com)
// or in .env.development.local for a local API on :3001.
const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.binviewer.com';

export default API_BASE;
